/**
 * @fileoverview Авария борта → конец смены.
 */

import { Snd } from "../audio/sound";
import type { GameHooks, GameState, Plane } from "../state/types";
import { pick, rnd } from "../util/math";

/** Авария борта — конец смены. */
export function crash(
  g: GameState,
  hooks: GameHooks,
  p: Plane,
  reason: string,
): void {
  if (g.over) return;
  p.crashed = true;
  p.dead = true;
  for (let i = 0; i < 46; i++) {
    g.sparks.push({
      x: p.x,
      y: p.y,
      vx: rnd(-260, 260),
      vy: rnd(-260, 260),
      t: rnd(0.5, 1.4),
      c: pick(["#ffd06b", "#ff8a4b", "#fff1c2", "#ff6b6b"]),
      s: rnd(1.5, 4),
    });
  }
  if (p.rwy !== null && g.runways[p.rwy]?.plane === p) {
    g.runways[p.rwy]!.plane = null;
  }
  for (const gate of g.gates) {
    if (gate.plane === p) gate.plane = null;
  }
  for (const r of g.runways) {
    if (r.reservedFor === p.id) {
      r.reservedFor = null;
      r.reserveT = 0;
      r.reserveLabel = "";
    }
  }
  p.gate = null;
  p.pendingGate = null;
  g.shake = 1;
  g.flash = 1;
  Snd.crash();
  hooks.endGame("Инцидент на поле", reason);
}
